import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../constants';
import './EmailSentPage.css';

type EmailSentLocationState = {
  email?: string;
};

export function EmailSentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const email = (location.state as EmailSentLocationState | null)?.email?.trim() ?? '';

  const sendEmailAgain = async () => {
    if (loading) {
      return;
    }

    if (!email) {
      navigate('/forgotten-password');
      return;
    }

    const request = { email };
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/forgotten-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        console.error('Passwort-E-Mail konnte nicht gesendet werden', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Passwort-E-Mail konnte nicht gesendet werden', error);
    } finally {
      setLoading(false);
    }
  };

  const navigateToLogin = () => navigate('/login');

  return (
    <main
      className="email-sent-page"
      style={{ '--email-sent-background-image': "url('/images/StartImage.jpg')" } as React.CSSProperties}
    >
      <section className="email-sent-page__card">
        <button
          type="button"
          onClick={navigateToLogin}
          className="email-sent-page__back"
          aria-label="Zurück zur Anmeldung"
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Zurück zur Anmeldung
        </button>

        <div className="email-sent-page__header">
          <div className="email-sent-page__badge">
            <svg viewBox="0 0 32 32" className="h-9 w-9" fill="none" aria-hidden="true">
              <rect x="4" y="7" width="23" height="17" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
              <path d="m5.5 9 10 7.5L26 9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="24.5" cy="22.5" r="5.5" fill="#d3ba87" />
              <path d="m22 22.5 1.7 1.7 3.1-3.6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <h1 className="email-sent-page__title">E-Mail versendet</h1>
          <p className="email-sent-page__description">
            Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts per E-Mail gesendet.
          </p>
        </div>

        <button
          type="button"
          onClick={navigateToLogin}
          className="email-sent-page__submit"
        >
          Zurück zur Anmeldung
        </button>

        <div className="email-sent-page__help">
          <p>Keine E-Mail erhalten?</p>
          <p className="email-sent-page__help-description">
            Prüfen Sie Ihren Spam-Ordner. Eine E-Mail wird nur versendet, wenn unter der verwendeten E-Mail Adresse ein Konto existiert.
          </p>
          <button
            type="button"
            onClick={sendEmailAgain}
            disabled={loading}
            className="email-sent-page__resend"
          >
            {loading ? 'E-Mail wird gesendet …' : 'E-Mail erneut senden'}
          </button>
        </div>
      </section>
    </main>
  );
}
